import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ICheckedListControlProps } from "./CheckedListControl";

class CheckedListControl2 extends React.Component<ICheckedListControlProps, never> {
    public render(): JSX.Element {
        var self = this;

        var css = null;
        if (this.props.limitTextWidth === true) {
            css = "text-ellipsis";
        }

        var sortedArray = this.props.DataSource.toArray();
        sortedArray = ArrayHelper.SortDynamic(sortedArray, "Name");

        return (
            <div className={css}>
                {sortedArray.filter((d: ICheckable) => d.Visible === true).map((c: ICheckable, idx: number) => {
                    var n = self.props.resolveValueInStringChange === true ? cacheStore.GetString(c.Name) : c.Name;
                    return (
                        <div key={idx + c.Id + "__c2"} className="checkbox">
                            <label>
                                <input onChange={self.onCheckChange.bind(self, c)} type="checkbox" checked={c.Checked} />
                                {n}
                            </label>
                        </div>
                    );
                })}
            </div>
        );
    }

    public onCheckChange(item: ICheckable, e: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.Operation);
        operation.AddItem("target", item.Target); // allows routing messages when several checkboxes with different but similar behaviors use the same LocalOperation
        operation.AddItem("checked", e.target.checked);
        operation.AddItem("id", item.Id);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { CheckedListControl2 };
